import { CellularPayPrompt } from './types'
import { isShutOff } from './sim-status'

// A back-bill blocks the CMS from the day it is raised: there is nothing to do but
// pay it or give the connection up. The quieter restore banner left after a give-up
// never locks anything, and neither does an ordinary renewal, whatever `blocking`
// says. Nor does a bill whose SIMs are all shut off for good: there is nothing
// left to pay for. Everything that depends on the lock asks this, never
// `prompt.blocking`.
export const isLocked = (prompt: CellularPayPrompt | null): boolean =>
  Boolean(prompt && prompt.isBackbill && prompt.blocking && !prompt.gaveUp && !isShutOff(prompt))
